import { render, staticRenderFns } from "./delivergood.vue?vue&type=template&id=2f94b308"
import script from "./delivergood.vue?vue&type=script&lang=js"
export * from "./delivergood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports